/* src/app/features/recuperacao/recuperacao-credito/calculo-valor-honrado-recuperar/calculo-valor-honrado-recuperar.component.scss */
.divResultado {
  margin-top: 30px;
}
/*# sourceMappingURL=calculo-valor-honrado-recuperar.component.css.map */
